import React from "react"
import { withPrefix } from "gatsby"
import Layout from "../../components/layout"
import SubNavigation from "../../components/sub-navigation"
import Hero from "../../components/hero"
import MegaQuote from "../../components/mega-quote"
import ReadNext from "../../components/read-next"
import { AppendixWaypoint, Appendix } from "../../components/appendix"

const PAGESLUG = "fintech"

export default function Fintech() {
  return (
    <Layout>
      <SubNavigation id="A Crisis Like No Other" current={PAGESLUG} />
      <Hero
        bgColor="green"
        bugColor="blue"
        video={withPrefix("/") + "video/fintech/hero_fintech.mp4?v=6"}
      />
      <section className="page__section">
        <div className="page__section__inner">
          <div className="container container--medium">
            <h1 className="page__title--opener">
              Financial technology—fintech—opens opportunities, especially for
              financial inclusion, but policymakers must also address the risks
            </h1>
            <p>
              Countries have broadly embraced the opportunities of financial
              technology—fintech—to boost economic growth and inclusion and
              reduce inequality while balancing risks to stability and integrity
              from cybercrime.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={1} />
            <p>
              And because of COVID-19, people are using even more online
              financial services than before.
            </p>
            <p>
              Whether fintech does more harm than good depends on the actions
              governments take to preserve trust, integrity, resilience,
              stability, and consumer protection.
            </p>

            <p>
              The IMF analyzed digital currencies such as stablecoins to help
              policymakers identify opportunities and pitfalls. The research
              showed that digital currencies can be an attractive means of
              payment, but policymakers need to develop farsighted regulations
              and legal foundations to minimize the risks.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={3} />
            <p>
              Requiring stablecoin providers to fully back coins with central
              bank reserves is one option. This is one way to make digital
              currencies backed by central banks a reality. Another option is
              for the central bank to provide its own digital currency to the
              public directly or through private sector distributors.
            </p>
            <p>
              All these new technologies depend on connectivity, yet internet
              usage remains a luxury: half of the world’s population does not
              have access to the internet. The digital divide—the gap between
              those who have internet access and those who don’t—is more like a
              chasm, both within and between countries.
            </p>
            <p>
              Part of the IMF’s work examined solutions in Asia to enhance
              connectivity to promote financial inclusion, enhance financial
              sector development, and increase inclusive growth potential,
              thereby reducing poverty.
            </p>
            <h3 className="page__quote">
              Harnessing fintech requires{" "}
              <em className="theme-color--green">
                closing the digital divide by bringing internet access
              </em>{" "}
              to the half of the world’s population that now lacks it.
            </h3>
            <p>
              More people online and working from home during the pandemic has
              created more opportunities for cybercrime. Improved global
              collaboration, more consistent regulations, and stronger
              supervision, combined with better crisis preparation and recovery
              planning, will help countries address such risks.
            </p>
            <AppendixWaypoint page={PAGESLUG} id={4} />
            <p>
              The IMF’s capacity development work supports the fight against
              cybercrime by helping countries develop the skills and expertise
              needed to recognize and mitigate cybersecurity threats.
            </p>
            <p>
              The IMF will continue to analyze and deepen the coverage of
              fintech in its annual checkups on the health of countries’
              economies and in regular Financial Sector Assessment Programs.
            </p>
          </div>
        </div>
      </section>
      <MegaQuote
        img="spotlights/fintech/fintech-end.jpg"
        alt="Green pastures"
        quote="The best memorial we can build to the people who have died in the pandemic is a greener, smarter, and fairer world.”"
        name="Kristalina Georgieva"
        jobTitle="IMF Managing Director"
      />
      <Appendix page={PAGESLUG} />
      <ReadNext sectionID="what-we-do" pageID="economic-surveillance" />
    </Layout>
  )
}
